export var getI18nKey = function (enTranslation, params) {
    if (!params) {
        return enTranslation
            .toLowerCase()
            .replace(/[^a-z\s]+/ig, '') // Убираем все лишние символы, оставляем только a-z и переменные типа {var}
            .replace(/\s+/g, ' ')
            .replace('.', '')
            .trim()
            .replace(/[\s]/g, '_');
    }
    return enTranslation
        .toLowerCase()
        .replace(/[^a-z{.*}\s]+/ig, '') // Убираем все лишние символы, оставляем только a-z и переменные типа {var}
        .replace(/\s+/g, ' ')
        .replace('.', '')
        .trim()
        .replace(/[\s]/g, '_');
};
export var isEnglish = function (text, params) {
    if (!params) {
        var englishAlphabet_1 = /^[A-Za-z0-9 ,.!?@#$%^&*(){}_+\-"']*$/;
        return englishAlphabet_1.test(text);
    }
    // Регулярное выражение, которое проверяет, содержит ли текст только символы английского алфавита, цифры, пробелы и знаки препинания (включая кавычки " ')
    var englishAlphabet = /^[A-Za-z0-9 ,.!?@#$%^&*()_+\-"']*$/;
    return englishAlphabet.test(text);
};
